<div class="app-body">
    <mat-toolbar *ngIf="isToolbarVisible" color='primary' class="darker mat-elevation-z8">
        <span style="cursor: pointer;" routerLink="/dashboard"><img class="cmg-logo" src="../assets/cmg.png" alt=""></span>
        <span class="spacer"></span>
        <a mat-raised-button *ngIf="isAdmin"  routerLink="/dashboard/admin" class="admin-button">Admin <mat-icon class="material-icons">settings_applications</mat-icon></a>
        <button mat-raised-button class="logout-button" (click)="logout()">Logout <mat-icon >logout</mat-icon></button>
      </mat-toolbar>
      
      <router-outlet></router-outlet>
</div>